module.exports = __webpack_public_path__ + "img/jej1.c3ac36e3.png";